import React from 'react'
import AudioPlayer from './AudioPlayer'
import { NavLink } from "react-router-dom"
import { getLoggedInUser, logout } from "../../services/AuthService"; 
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getMetadata, updateMetadata } from '../../services/MetadataService';
import { isLargeScreen } from "../../utilities/ScreenView";

const Header = () => {
    const [datatype, setDatatype] = useState('boolean')

    const [checked1, setChecked1] = useState(true);
    const [checked2, setChecked2] = useState(false);
    const [checked3, setChecked3] = useState(false);
    const [checked4, setChecked4] = useState(true);

    const navigator = useNavigate()

    var { messageApp, openMarket, strategyTab, dukasGraphs } = useParams()

    messageApp  = "message.app"
    openMarket  = "open.market"
    strategyTab = "strategy.tab"
    dukasGraphs = "dukas.graphs"

    useEffect(() => {
        const interval = setInterval(() => { listMetadata(messageApp); listMetadata(openMarket); listMetadata(strategyTab) }, 10000);
        return () => {  clearInterval(interval); }
    });    

    function  listMetadata(name) {
        getMetadata(name).then((response) => {
            // console.log(response.data);
            setDatatype(response.data.datatype);
            switch(name) {
                case messageApp  : setChecked1(response.data.value.toLowerCase() === "true"); break;
                case openMarket  : setChecked2(response.data.value.toLowerCase() === "true"); break;
                case strategyTab : setChecked3(response.data.value.toLowerCase() === "true"); break;
                case dukasGraphs : setChecked4(response.data.value.toLowerCase() === "true"); break;
                default          : break;
            }
        }).catch(error => {
            console.log(error);
        })
    }

    function showUser() {
        return <span style={{ color: '#00a8af'}}>{getLoggedInUser()}</span>
    }
    
    function handleLogout() {
        logout();
        navigator('/login')
    }

    function setMessageApp(checked) {
        saveOrUpdateMetadata(messageApp, checked.toString());
    }

    function setOpenMarket(checked) {
        saveOrUpdateMetadata(openMarket, checked.toString());
    }

    function setStrategyTab(checked) {
        saveOrUpdateMetadata(strategyTab, checked.toString());
    }

    function setDukasGraphs(checked) {
        saveOrUpdateMetadata(dukasGraphs, checked.toString());
    }

    function saveOrUpdateMetadata(name, value) {
        const metadata = { name, datatype, value }
        updateMetadata(name, metadata).then((response) => {
            // console.log(response.data)
        }).catch(error => {
            console.log(error);
        })
    }

    function config() {
        // if (checked1 !== undefined) {}
        // console.log("Telegram.checked1    = " + checked1);
        return (
                <>
                    <div className="row justify-content-md-left">
                        <div className={isLargeScreen() ? "col" : "col"}>
                            <label style={{
                                backgroundColor: 'white',
                                fontSize: 'small',
                                textAlign: 'left',
                                float: 'left',
                                fontStyle: 'italic'
                            }} className="form-check-label" htmlFor="messageApp">Telegram</label>
                        </div>
                        <div className="col form-check form-check-inline form-switch">
                            <input className="form-check-input"
                                   type="checkbox"
                                   id="messageApp"
                                   name="messageApp"
                                   onChange={(e) => setMessageApp(e.target.checked)}
                                   defaultChecked={checked1}/>
                        </div>
                        <div className={isLargeScreen() ? "col" : "col"}>
                            <label style={{
                                backgroundColor: 'white',
                                fontSize: 'small',
                                textAlign: 'left',
                                float: 'left',
                                fontStyle: 'italic'
                            }} className="form-check-label" htmlFor="openMarket">Open Market</label>
                        </div>
                        <div className="col form-check form-check-inline form-switch">
                            <input className="form-check-input"
                                   type="checkbox"
                                   id="openMarket"
                                   name="openMarket"
                                   onChange={(e) => setOpenMarket(e.target.checked)}
                                   defaultChecked={checked2}/>
                        </div>
                        <div className={isLargeScreen() ? "col" : "col"}>
                            <label style={{
                                backgroundColor: 'white',
                                fontSize: 'small',
                                textAlign: 'left',
                                float: 'left',
                                fontStyle: 'italic'
                            }} className="form-check-label" htmlFor="strategy">Strategy</label>
                        </div>
                        <div className="col form-check form-check-inline form-switch">
                            <input className="form-check-input"
                                   type="checkbox"
                                   id="strategy"
                                   name="strategy"
                                   onChange={(e) => setStrategyTab(e.target.checked)}
                                   defaultChecked={checked3}/>
                        </div>
                        <div className={isLargeScreen() ? "col" : "col"}>
                            <label style={{
                                backgroundColor: 'white',
                                fontSize: 'small',
                                textAlign: 'left',
                                float: 'left',
                                fontStyle: 'italic'
                            }} className="form-check-label" htmlFor="dukasgraphs">Dukasgraphs</label>
                        </div>
                        <div className="col form-check form-check-inline form-switch">
                            <input className="form-check-input"
                                   type="checkbox"
                                   id="dukasgraphs"
                                   name="dukasgraphs"
                                   onChange={(e) => setDukasGraphs(e.target.checked)}
                                   defaultChecked={checked4}/>
                        </div>
                        <div className="col">
                            <i>Hello</i>&nbsp;{showUser()}&nbsp;!&nbsp;<NavLink
                            style={{backgroundColor: 'white', fontSize: 'small'}} to="/login"
                            onClick={handleLogout}>Logout</NavLink>
                        </div>
                    </div>
                    <AudioPlayer/>
                </>
        )
    }

    return (
        <div className="col-sm-14 mt-2">
                <span style={{backgroundColor: '#00a8af', fontSize: 'small'}}
                      class="nav-link p-2 shadow-sm rounded-5 bg-gradient text-white text-center">
                    ABrFx&reg;&nbsp;Nahzar Trading System - Stocks, Currencies, Metals and Commodities Marketplace
                </span>
                <span style={{ backgroundColor: 'white', fontSize: 'small'}} className="nav-link p-1 shadow-sm rounded-5 bg-gradient text-primary text-end" >
                        { config() }
                </span>
                {/* <h1>{check ? 'Checked' : 'Not checked'}</h1> */}
            </div>
    )
}

export default Header